module.exports = __webpack_public_path__ + "img/9788960512245.3af77d27.jpg";